import { useEffect, useRef, useState } from "react";
import { ManufacturedProductsViewModel } from "../../viewmodels/production/ManufacturedProductsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { formatDateWithTime, withRouter } from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";

import EmptyModal from "../../components/modals/EmptyModal";
import ActionButton from "../../components/controls/ActionButton";
import ActionLink from "../../components/controls/ActionLink";

import { Paginator } from "primereact/paginator";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import ReportsDropdown from "../../components/filterDropdown/ReportsDropdown";
import Pills from "../../components/controls/Pills";
import { productionStatusOptions } from "../../shared/utility";
import StatsComponents from "../../components/stats/StatsComponents";

function ManufacturedProducts(props) {
  const { addSnackbar, logout } = props;
  const {
    emptyModal,
    fetchRecipesForDropdown,
    getCertifiedByOptionsForDropdown,
    getManufacturedProducts,
    loading,
    productionHistories,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    askDeleteManufacturedProduct,
    filters,
    resetFilters,
    showFilters,
    setShowFilters,
    filterComponents,
    getEmployeesForDropdown,
    generateProductionReport,
    reportComponents,
    showReports,
    setShowReports,
    reportInProgress,
    analytics,
    setFilters,
    setShowDates,
    showDates,
    fetchProductsForDropdown,
  } = ManufacturedProductsViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    fetchRecipesForDropdown();
    getEmployeesForDropdown(2, [1, 3]);
    getEmployeesForDropdown(1, [1, 3]);
    getCertifiedByOptionsForDropdown();
    fetchProductsForDropdown();
    getManufacturedProducts(null, currentPage, filters);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  const searchRef = useRef();

  const handleSearch = () => {
    getManufacturedProducts(searchRef.current.value, currentPage, filters);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getManufacturedProducts(searchRef.current.value, currentPage, filters);
  };

  const convertProductStatus = (status) => {
    const statusOption = productionStatusOptions.filter(
      (el) => el.value === status,
    );

    return statusOption.length === 1
      ? { text: statusOption[0].label, type: statusOption[0].type }
      : {
          text: productionStatusOptions[0].label,
          type: productionStatusOptions[0].type,
        };
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8 space-y-2">
          <StatsComponents
            analytics={analytics}
            setFilters={setFilters}
            filters={filters}
            setShowDates={setShowDates}
            showDates={showDates}
            handleSearch={handleSearch}
            filtersEnabled={true}
            showFilters={showFilters}
            filterComponents={filterComponents}
            resetFilters={resetFilters}
            setShowFilters={setShowFilters}
          />
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Manufactured Products
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchProduct"
                    id="searchProduct"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by name"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>

                <ReportsDropdown
                  actionCall={generateProductionReport}
                  reportComponents={reportComponents}
                  showReports={showReports}
                  setShowReports={setShowReports}
                  title="Reports"
                  reportInProgress={reportInProgress}
                />
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="overflow-hidden card-custom">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            PLU
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Lot Number
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Target Weight
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Production Date
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {productionHistories.data.length > 0
                          ? productionHistories.data.map((product, index) => (
                              <tr key={product.id}>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {product.plu}
                                </td>
                                <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                  {product.product_name}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {product.lot_number}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {product.new_weight} kg
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {formatDateWithTime(product.production_date)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  <Pills
                                    content={convertProductStatus(
                                      product.status,
                                    )}
                                  />
                                </td>
                                <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                  <ActionLink
                                    to={"/manufactured-products/" + product.id}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View details
                                  </ActionLink>
                                  <ActionButton
                                    color="red"
                                    onClick={() => {
                                      askDeleteManufacturedProduct(product);
                                    }}
                                    className="ml-2"
                                  >
                                    Delete
                                  </ActionButton>
                                </td>
                              </tr>
                            ))
                          : "Empty"}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="w-full">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={productionHistories.total}
                  onPageChange={handlePagination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManufacturedProducts),
);
